import { Injectable } from "@angular/core";
import { ISede } from "app/shared/models/sedi.interface";
import { BASEMysqlService } from "./_base";
@Injectable({
  providedIn: 'root'
})
export class MysqlServiceSedi extends BASEMysqlService {

  prefix = 'sedi_'

  //////////////////////////////////////////////////////////////////////////////////////////

  list(idAzienda?: number): Promise<any> {
    let data = {
      auth: this.getAuth(),
      idAzienda: idAzienda
    }

    // console.log(data)

    return this.http.post(this.URL_BASE + this.prefix + 'list', data).toPromise();
  }

  get(id): Promise<any> {
    let data = {
      auth: this.getAuth(),
      id: id
    }

    // console.log(data)

    return this.http.post(this.URL_BASE + this.prefix + 'get', data).toPromise();
  }

  upsert(item: ISede): Promise<ISede[]> {
    let data = {
      auth: this.getAuth(),
      item: item
    }

    return this.http.post<ISede[]>(this.URL_BASE + this.prefix + 'upsert', data).toPromise();
  }

  delete(id: number): Promise<any> {
    let data = {
      auth: this.getAuth(),
      id: id
    }

    return this.http.post(this.URL_BASE + this.prefix + 'delete', data).toPromise();
  }

}